import React, { useEffect, useState } from 'react';
import { useBunkerContext } from 'src/context/BunkerContext';
import { ButtonWrapper, TabButton, TabLineButton, TabsWrapper } from 'src/styles/button.style';
import { TabsPanelHeader } from 'src/styles/panel.style';
import { BunkeringPageTabs, getNumUnregisteredBunkeringEvents } from './BunkeringUtils';
import { useAuthStore } from 'src/context/AuthContext';
import UpdateInfoComponent from '../common/UpdateInfo';
import { RedIcon } from '../ui/status-icon/VerificationIcon.styles';

interface BunkeringPageHeaderProps {
    onSaveReport: () => void;
}

const BunkeringPageHeader: React.FC<BunkeringPageHeaderProps> = ({ onSaveReport }) => {
    const {
        selectedBunkeringTab,
        setSelectedBunkeringTab,
        bunkeringEvents,
        bunkerings,
        selectedBunkeringDate,
        saveButtonEnabled,
        selectedBunkering,
    } = useBunkerContext();
    const { role } = useAuthStore();

    const [numUnregisteredBunkerings, setNumUnregisteredBunkerings] = useState(0);
    const [numUnregisteredDebunkerings, setNumUnregisteredDebunkerings] = useState(0);

    useEffect(() => {
        const [_numUnregisteredBunkerings, _numUnregisteredDebunkerings] = getNumUnregisteredBunkeringEvents(
            bunkeringEvents,
            bunkerings,
            selectedBunkeringDate
        );
        setNumUnregisteredBunkerings(_numUnregisteredBunkerings);
        setNumUnregisteredDebunkerings(_numUnregisteredDebunkerings);
    }, [bunkeringEvents, bunkerings, selectedBunkeringDate]);

    return (
        <TabsPanelHeader columns={'80% 20%'}>
            <TabsWrapper tabs={'125px 125px'}>
                <TabButton
                    className="first"
                    isSelected={selectedBunkeringTab === BunkeringPageTabs.rob}
                    onClick={() => {
                        setSelectedBunkeringTab(BunkeringPageTabs.rob);
                    }}
                >
                    ROB
                </TabButton>
                <TabButton
                    className="seperate-from-group"
                    isSelected={selectedBunkeringTab === BunkeringPageTabs.registration}
                    onClick={() => {
                        setSelectedBunkeringTab(BunkeringPageTabs.registration);
                    }}
                >
                    Bunkering
                    {numUnregisteredBunkerings + numUnregisteredDebunkerings > 0 && (
                        <RedIcon title={'Unregistered bunkering events'}>{numUnregisteredBunkerings + numUnregisteredDebunkerings}</RedIcon>
                    )}
                </TabButton>
            </TabsWrapper>
            <ButtonWrapper>
                {selectedBunkering && selectedBunkeringTab === BunkeringPageTabs.registration && (
                    <UpdateInfoComponent lastUpdatedUtc={selectedBunkering.lastUpdatedAt} lastUpdatedBy={selectedBunkering.lastUpdatedBy} />
                )}

                {role.isWriter && (
                    <TabLineButton type="button" onClick={() => onSaveReport()} disabled={!saveButtonEnabled}>
                        Save
                    </TabLineButton>
                )}
            </ButtonWrapper>
        </TabsPanelHeader>
    );
};

export default BunkeringPageHeader;
